import { Injectable } from '@angular/core';
import { UsuarioLogado } from '../models/usuario-logado';
import { Login } from '../models/login';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { globals } from '../globals';
import { TipoDeLogin } from '../models/enum';
import { SignalRService } from './signal-r.service';
import { AccessToken } from '../models/access-token';

@Injectable({
  providedIn: 'root',
})
export class AutenticacaoService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
    private signalRService: SignalRService,
  ) {}

  login(login: Login) {
    localStorage.removeItem('feedIntegradores');

    return this.http.post<any>(globals.apiUrl + '/api/v2/account/login', login, { withCredentials: true });
  }

  logout() {
    return this.http.post<void>(globals.apiUrl + '/api/v2/account/logout', {}, { withCredentials: true });
  }

  logoutLocal() {
    this.signalRService.closeConnection();
    this.limpaStorage();
  }

  renovarAcesso() {
    return this.http.post<AccessToken>(globals.apiUrl + '/api/v2/account/refresh-token', {}, { withCredentials: true });
  }

  logado() {
    return localStorage.getItem('token') !== null;
  }

  salvarToken(data: AccessToken) {
    localStorage.setItem('token', JSON.stringify(data));
  }

  obterToken(): AccessToken {
    return JSON.parse(localStorage.getItem('token'));
  }

  private limpaStorage() {
    if (localStorage.getItem('calculadora')) {
      const calc = JSON.parse(localStorage.getItem('calculadora'));
      calc.idCliente = null;
      calc.idVendedor = null;

      localStorage.setItem('calculadora', JSON.stringify(calc));
    }

    localStorage.removeItem('filtroOcorrencia');
    localStorage.removeItem('filtroPedido');
    localStorage.removeItem('filtroRepasse');
    localStorage.removeItem('token');
    localStorage.removeItem('feedIntegradores');
    localStorage.removeItem('filtroMonitorProposta');
  }

  roleMatch(allowedRoles, userRoles): boolean {
    let isMatch = false;
    allowedRoles.forEach((element) => {
      if (userRoles.indexOf(element) > -1) {
        isMatch = true;
        return false;
      }
    });
    return isMatch;
  }

  isIntegrador(userRoles): boolean {
    return userRoles.find((p) => p === 'Integrador' || p === 'Contato/Integrador') ? true : false;
  }

  isVendedor(userRoles): boolean {
    return userRoles.find((p) => p === 'Vendedor') ? true : false;
  }

  liberarAcesso(tipo: TipoDeLogin, id, url) {
    return this.http.post(
      globals.apiUrl +
        '/api/Autenticacao/LiberarAcesso' +
        (tipo === TipoDeLogin.Integrador ? 'Integrador' : 'Vendedor'),
      {
        id,
        url,
      },
    );
  }

  esqueceuSenha(email: string, url: string, desafio: string | null = null) {
    const data = {
      email: email,
      url: url,
      desafio: desafio,
    };

    return this.http.post(globals.apiUrl + '/api/Autenticacao/EsqueceuSenha', data);
  }

  resetarSenha(id: number, senha, token) {
    return this.http.post(globals.apiUrl + '/api/Autenticacao/ResetarSenha', {
      id,
      senha,
      token,
    });
  }

  bloquearAcessoVendedor(id) {
    return this.http.get(globals.apiUrl + '/api/Autenticacao/BloquearAcessoVendedor', {
      params: new HttpParams().set('id', id),
    });
  }

  podeVerCustos() {
    return this.http.get(globals.apiUrl + '/api/Autenticacao/PodeVerCustos', { responseType: 'text' });
  }

  buscarUsuarioLogado() {
    return this.http.get<UsuarioLogado>(globals.apiUrl + '/api/Autenticacao/BuscarUsuarioLogado');
  }
}
